import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Layers, LogOut, BookOpen, Library, Settings } from "lucide-react";
import { LibraryDialog } from "@/components/LibraryDialog";
import { getLibrary } from "@/lib/iwin";
import { CatalogueDialog } from "@/components/CatalogueDialog";
import { useCatalogues } from "@/context/CatalogueContext";
import { useAuth } from "@/context/AuthContext";

export const AppHeader = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [catOpen, setCatOpen] = useState(false);
  const [libOpen, setLibOpen] = useState(false);
  const { catalogues } = useCatalogues();
  const nSeries = catalogues.filter((c) => c.status === "ready").reduce((a, c) => a + c.series.length, 0);
  return (
    <header className="sticky top-0 z-30 h-14 px-4 flex items-center gap-4 border-b border-slate-800 bg-[#0B0F19]/95 backdrop-blur-md">
      <Link to="/dashboard" className="flex items-center gap-2 shrink-0" data-testid="header-home-link">
        <Layers className="text-cyan-400" size={20} />
        <span className="font-heading font-bold tracking-tight hidden sm:inline">AluDraft<span className="text-cyan-400">.ai</span></span>
      </Link>
      <div className="flex-1 min-w-0 flex items-center gap-3">{children}</div>
      <div className="flex items-center gap-2 shrink-0">
        <button data-testid="open-library-btn" onClick={() => getLibrary() && setLibOpen(true)} title="IWIN-S product library"
          className="h-8 px-2.5 rounded-md border border-slate-700 text-xs text-slate-200 flex items-center gap-1.5 hover:border-amber-400 hover:text-amber-200 transition-colors">
          <Library size={14} /><span className="hidden md:inline">IWIN-S</span>
        </button>
        <button data-testid="open-catalogue-btn" onClick={() => setCatOpen(true)} title="YKK AP catalogue"
          className="h-8 px-2.5 rounded-md border border-slate-700 text-xs text-slate-200 flex items-center gap-1.5 hover:border-cyan-500 hover:text-cyan-300 transition-colors">
          <BookOpen size={14} /><span className="hidden md:inline">Catalogue</span>
          {nSeries > 0 && <span className="font-mono text-[10px] px-1.5 rounded bg-cyan-500/20 text-cyan-300" data-testid="catalogue-series-count">{nSeries}</span>}
        </button>
        <Link to="/settings" data-testid="open-settings-btn" title="Team & devices"
          className="h-8 w-8 grid place-items-center rounded-md text-slate-400 hover:text-cyan-300 hover:bg-slate-800 transition-colors"><Settings size={16} /></Link>
        {user?.picture && <img src={user.picture} alt="" className="w-7 h-7 rounded-full border border-slate-700" data-testid="user-avatar" />}
        <span className="text-sm text-slate-400 hidden lg:inline" data-testid="user-name">{user?.name}{user?.role === "staff" && <span className="ml-1.5 text-[10px] font-mono uppercase text-slate-500">staff</span>}</span>
        <button data-testid="logout-btn" title="Log out" onClick={async () => { await logout(); navigate("/"); }}
          className="h-8 w-8 grid place-items-center rounded-md text-slate-400 hover:text-rose-400 hover:bg-slate-800 transition-colors">
          <LogOut size={16} />
        </button>
      </div>
      {catOpen && <CatalogueDialog onClose={() => setCatOpen(false)} />}
      {libOpen && <LibraryDialog onClose={() => setLibOpen(false)} />}
    </header>
  );
};
